if (typeof sswRun === 'function') {
      sswRun(function(){
        const redirectUrl = 'https://g.page/r/CXTbEay1rmDZEA0/review';
        const textLeaveReview = 'Leave us review on google and get';
        const pointsAmount = 200;
        
        const leaveReviewActionInTab =  `<a href="${redirectUrl}">`+ 
        								  '<div class="ssw-reward-box-earning-rule" data-type="leave_review">' +
                                            '<div class="ssw-reward-inline ssw-reward-box-earning-rule-info-wrapper">'+
                                              '<div class="ssw-reward-inline ssw-reward-box-rule-icon-wrapper">'+
                                                '<div class="ssw-square">'+
                                                  '<i class="ssw-icon-star"></i>'+
                                                  '<svg version="1.1" class="ssw-square-border" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"><g><path fill="transparent" d="M10,0h20c5.5,0,10,4.5,10,10v20c0,5.5-4.5,10-10,10H10C4.5,40,0,35.5,0,30V10C0,4.5,4.5,0,10,0z"></path></g><path fill="none" stroke="#546E7A" id="ssw-square-border" stroke-miterlimit="10" d="M20,0.5h9.8c5.3,0,9.7,4.3,9.7,9.7V20v9.8c0,5.3-4.3,9.7-9.7,9.7H20 h-9.8c-5.3,0-9.7-4.3-9.7-9.7V10.2c0-5.3,4.3-9.7,9.7-9.7H20z"></path></svg>'+
                                                '</div>'+
                                              '</div>'+
                                              '<div data-earning-rule="leave_review" class="ssw-reward-inline ssw-reward-box-rule-description" onclick="takeMeTo()">'+
                                                `<div class="ssw-reward-box-text ssw-reward-box-earning-rule-title"> ${textLeaveReview} </div>`+
                                                `<div class="ssw-reward-box-text ssw-reward-box-earning-rule-desc"><span class="ssw-earn-points-count">${pointsAmount}</span> points</div>`+
                                                '<div data-rule-name="leave_review" class="ssw-reward-box-text ssw-reward-box-earning-rule-description">g</div>'+
                                              '</div>'+
                                            '</div>'+
                                          '</div>'
        								 '</a>';
        const leaveReviewActionRewardPage = `
                                        <a href="${redirectUrl}" class="ssw-reward-page-earning-rule">                                    
										   <div class="ssw-reward-page-rule-icon-wrapper ssw-text-center">
                                            <div class="ssw-square-big">
                                              <i class="ssw-icon-star"></i>
                                              <svg version="1.1" class="ssw-square-border" xmlns="http://www.w3.org/2000/svg"
                                                   xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 52 52"
                                                   enable-background="new 0 0 52 52" xml:space="preserve">
                                                      <g>
                                                        <path fill="transparent"
                                                              d="M13.5,1h25C45.4,1,51,6.6,51,13.5v25C51,45.4,45.4,51,38.5,51h-25C6.6,51,1,45.4,1,38.5v-25C1,6.6,6.6,1,13.5,1z"></path>
                                                      </g>
                                                <path id="ssw-square-border" fill="none" stroke="#546E7A" stroke-width="2" stroke-miterlimit="10"
                                                      stroke-dasharray="178.6449,178.6449" d="
                                                      M26,1h12.6C45.4,1,51,6.5,51,13.4V26v12.6C51,45.4,45.5,51,38.6,51H26H13.4C6.6,51,1,45.5,1,38.6V13.4C1,6.6,6.5,1,13.4,1H26z"></path>
                                                    </svg>
                                            </div>
                                          </div>
                                          <div class="ssw-reward-page-rule-title ssw-text-center">  ${textLeaveReview}</div>
                                          <div class="ssw-reward-page-rule-earn ssw-text-center">

                                            <span class="ssw-earn-points-count">${pointsAmount}</span> points
                                          </div>
                                          </div>
										 </a>`;
             
        var renderCustomReviewAction = function (tab = false) {
          var isRewardPage = location.pathname == "/pages/reward";
          if (tab) isRewardPage = !tab;
          var __sswIntervalRewardTab = setInterval(function() {
            var sswRewardBoxEarningRules = isRewardPage
            	? ssw('#ssw-reward-page-earning-rules-wrapper .ssw-reward-page-earning-rules')
                : ssw('#ssw-reward-box-earning-rules');
            if (sswRewardBoxEarningRules.length && !sswRewardBoxEarningRules.hasClass('ssw-initialized')) {
              clearInterval(__sswIntervalRewardTab);
              sswRewardBoxEarningRules.addClass('ssw-initialized');
                if (isRewardPage) {
                    sswRewardBoxEarningRules.prepend(leaveReviewActionRewardPage);
                    ssw('a.ssw-reward-load-more-link').click();
                } 
              	else {
                  	sswRewardBoxEarningRules.prepend(leaveReviewActionInTab)
                }
            }
          }, 300)
        };
      	renderCustomReviewAction();
        
        ssw(document).on('click','.ssw-reward-tab, .ssw-reward-page-header .ssw-reward-page-menu', function () {
          renderCustomReviewAction()
        })
        
        ssw(document).on('click','.ssw-reward-tab, .ssw-reward-box-side .ssw-reward-box-menu', function () {
          renderCustomReviewAction(true)
        })
        
      })
    }